// App.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import SignUp from './SignUp';
import Blog from './Blog';  // Assume you have a Home component
import Login from './Login';
import Shop from './Shop';
import MobileVerify from './MobileVerify';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/sign-up" Component={SignUp} />
        <Route path="/login" Component={Login} />
        <Route path="/" Component={Blog} />
        <Route path="*" Component={Blog} />
        <Route path="/shop" Component={Shop} />
        <Route path="/mobileVerify" Component={MobileVerify} />
      </Routes>
    </Router>
  );
}

export default App;
